import jwt from 'jsonwebtoken';

import { getTokenAndStorage } from 'startup';

export default function destructureJwt() {
  const { token } = getTokenAndStorage(window);
  return {
    characterId: extractOrReturnUndefined(token, 'CharacterId'),
    userId: extractOrReturnUndefined(token, 'UserId'),
    exp: extractOrReturnUndefined(token, 'exp'),
  };
}

function extractOrReturnUndefined(token, key) {
  try {
    const value = jwt.decode(token)[key];
    if (Number(value)) {
      return Number(value);
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
}